<template>
  <div class="platParent" :style="{ backgroundColor: bgColor }">
    <title-widge
      :title="title"
      :subTitle="subTitle"
      :titleColor="titleColor"
      :prevImg="prevImg"
      :nextImg="nextImg"
    ></title-widge>
    <div class="divImg">
      <img v-for="(item, index) in items" :key="index" v-lazy="{
        src:item,
        loading: require('./../../../../../assets/wheelplanting.jpg'),
      }" />
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "",
    },
    prevImg: {
      type: String,
      default: require("./../img/title_prev.png"),
    },
    nextImg: {
      type: String,
      default: require("./../img/title_next.png"),
    },
    items: {
      type: Array,
      default: () => [],
    },
    bgColor: {
      type: String,
      default: "",
    },
  },
  components: {
    titleWidge,
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./../scss/platDisplayWidge.scss";
</style>
